import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

export const formControlSx: SxProps<Theme> = {
    margin: 0,
};

export const radioGroupSx: SxProps = {
    display: 'flex',
    maxWidth: theme.spacing(200 / 8),
    flexDirection: 'column',
    flexWrap: 'nowrap',
    '& .MuiFormControlLabel-root': {
        margin: 0,
        '&:first-of-type .MuiTypography-root': {
            borderRadius: '4px 0 0 4px',
        },
        '&:last-of-type .MuiTypography-root': {
            borderRadius: ' 0 4px 4px 0',
        },
    },
    '& .MuiRadio-root': {
        display: 'none',
    },
    '& .MuiTypography-root': {
        minWidth: theme.spacing(100 / 8),
        padding: theme.spacing(10 / 8, 20 / 8),
        borderWidth: theme.spacing(1 / 8),
        borderStyle: 'solid',
        borderColor: theme.palette.neutral[200],
        color: theme.palette.neutral[700],
        fontWeight: 500,
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
    },
    '& .Mui-checked + .MuiTypography-root': {
        color: theme.palette.primary.main,
        borderColor: theme.palette.primaryColor[100],
        background: theme.palette.primaryColor.A50,
    },
};
